import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SPLITTER_CONFIG } from "../../config/splitterConfig";

const Splitter = ({ variant = "login" }) => {
  const { t } = useTranslation();
  const config = SPLITTER_CONFIG[variant];

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: config.bgColor,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          color: "#fff",
          fontWeight: 600,
          maxWidth: "220px",
          fontSize: "24px",
          fontFamily: "Poppins, sans-serif",
          lineHeight: 1.4,
          padding: "48px 32px 0 32px",
        }}
      >
        {t(config.translationKey)}
      </Typography>

      <img
        src={config.vector}
        alt={`${variant} vector`}
        className={config.vectorClass}
      />
    </Box>
  );
};

export default Splitter;
